// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class DeleteElementDataByIdReducer extends Reducer
{
	public static reducerName: string = "DeleteElementDataById";
	public static call(_id: number) {
		this.getReducer().call(_id);
	}

	public call(_id: number) {
		const serializer = this.client.getSerializer();
		let _idType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_idType, _id);
		this.client.call("DeleteElementDataById", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let idType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let idValue = AlgebraicValue.deserialize(idType, adapter.next())
		let id = idValue.asNumber();
		return [id];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _id: number) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _id: number) => void)
	{
		this.client.on("reducer:DeleteElementDataById", callback);
	}
}


export default DeleteElementDataByIdReducer
